<template>
  <div class="mb-2">
    <template v-if="!editing">
      <slot name="label">
        <v-list-item-title class="" v-if="!hideLabel"
          >{{ label }}:</v-list-item-title
        >
      </slot>
      <slot name="value">
        <span>{{ valueModel }}</span>
      </slot>
    </template>
    <template v-else>
      <slot name="edit">
        <v-text-field v-model="valueModel" :label="label" dense />
      </slot>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'EditableField',
    props: {
      value: {},
      label: {
        type: String,
        default: '',
      },
      editing: {
        default: 0,
      },
      cancel: {
        type: Boolean,
        default: false,
      },
      keyPath: {
        type: String,
        required: true,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        valueModel: this.value,
      }
    },
    watch: {
      value(newVal) {
        this.valueModel = newVal
      },
      editing(newVal) {
        if (!newVal) {
          this.saveEdit()
        }
      },
      cancel() {
        this.valueModel = this.value
      },
    },
    methods: {
      saveEdit() {
        this.$emit('save', { keyPath: this.keyPath, value: this.valueModel })
        this.valueModel = this.value
      },
    },
  }
</script>
